export const DEBOUNCE_TIME = 300;

export enum ClientType {
  Client = 'client',
  Prospect = 'prospect',
}
